import React from "react"

import { TeeUpsPage } from "../../pages"

export const ArchivePage = () => <TeeUpsPage />
